import { Modal } from 'bootstrap.native';

export class OrderLines {
    /**
    * Controller for OrderDetails
    */
    constructor(element) {
        // Name, reference
        element.OrderLines = this;

        // References
        this.el = element;
        this._refs = {
            serialnumbers: Array.from(this.el.querySelectorAll('.serialnumber')),
            dialog: this.el.parentElement.querySelector('#serialNumbersModal')
        };

        // Events
        this._refs.serialnumbers.forEach(item => item.addEventListener('click', this._onSerialItemLinkClick.bind(this)));
    }

    /**
     * onSerialItemLinkClick
     * When user clicks on serialnumber-links to show a modal with all serialnumbers for an orderline
     * @param {Event} e - event interface
     */
    _onSerialItemLinkClick(e) {
        e.preventDefault();

        let serialnumbers = e.target.title || null;
        let title = e.target.getAttribute("data-label") || "";
        if (!!serialnumbers) {
            let modal = new Modal(this._refs.dialog, {
                content: this._template(serialnumbers, title)
            });

            modal.show();
        }
    }

    /**
     * template 
     * Template for displaying modal with serial numbers
     * @param {string} serialnumbers - string of serial numbers
     * @param {string} title - popup title
     */
    _template(serialnumbers, title) {
        return '<div class="modal-header">'
            + '<h4 class="modal-title">' + title + '</h4>'
            + '</div>'
            + '<div class="modal-body">'
            + serialnumbers +
            '</div>' +
            '<div class="modal-footer">' +
            '<button class="btn-primary" data-dismiss="modal">OK</button>' +
            '</div>';
    }
}
